import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=48e06c4e&scoped=true&"
import script from "./PaymentList.vue?vue&type=script&lang=js&"
export * from "./PaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=48e06c4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e06c4e",
  null
  
)

export default component.exports